import { Grid, Icon, Checkbox } from "semantic-ui-react";
import {
  formatDate,
  showElementFullTextPopup,
  getUserNameEmailString,
  getAssetTypeString,
  getFileSizeLabel,
  formatFileSizeAndDuration,
  handleDownloadClick,
  formatLanguageForAsset,
  formatDPIForAsset,
  formatMotiveMarkerForAsset,
} from "services/common";
import { useState, useRef, useEffect } from "react";
import _ from "lodash";
import AssetImage from "components/AssetImage/AssetImage";
import AssetAPIInfoTable from "components/AssetAPIInfoTable/AssetAPIInfoTable";

const ASSET_KEYS = [
  "name",
  "imgSrc",
  "resolution",
  "type",
  "audio",
  "dpi",
  "dynamicContent",
  "motiveMarker",
  "lowResolution",
  "fileSize",
  "framerate",
  "createdAt",
  "updatedAt",
  "start_time",
  "end_time",
  "week_days",
  "language",
  "printServiceID",
  "sentToPrintServiceDate",
  "senderToPrintService",
  "startprint_sender",
  "owner",
  "notes",
  "isProcessed",
];

const ASSET_KEYS_CONTRIBUTOR = [
  "name",
  "imgSrc",
  "resolution",
  "type",
  "dpi",
  "audio",
  "dynamicContent",
  "motiveMarker",
  "lowResolution",
  "fileSize",
  "framerate",
  "createdAt",
  "updatedAt",
  "start_time",
  "end_time",
  "week_days",
  "language",
  "notes",
];

const AssetInfoValues = ({ asset, assetKey, agencys, users, t }) => {
  const attributeRef = useRef(null);
  const [isLoaded, setIsloaded] = useState(false);
  const formatPrintService = (id) => {
    const printService = _.find(agencys, ["id", id]);
    return printService ? (
      printService.name
    ) : (
      <span style={{ backgroundColor: "yellow" }}>{t("asset_info_print_service_not_found")}</span>
    );
  };
  const formatScheduledDays = (scheduledDays) => {
    const weekdays = [
      t("playday_monday"),
      t("playday_tuesday"),
      t("playday_wednesday"),
      t("playday_thursday"),
      t("playday_friday"),
      t("playday_saturday"),
      t("playday_sunday"),
    ];
    const playDays = Object.assign(
      ...weekdays.map((day, index) => ({ [day]: parseInt([...scheduledDays][index]) }))
    );
    return Object.keys(playDays)
      .filter((day) => playDays[day])
      .join(", ");
  };
  const formatUser = (id) => {
    const user = users && users.find((user) => user.id === id);
    return user ? (
      getUserNameEmailString(user)
    ) : (
      <span style={{ backgroundColor: "yellow" }}>{t("asset_info_user_not_found")}</span>
    );
  };

  const renderCheckIcon = (bool) => {
    const text = bool ? (
      <span>
        <Icon name="check" />
      </span>
    ) : null;
    return text;
  };

  useEffect(() => {
    const refElement = attributeRef.current;
    refElement && setIsloaded(true);
  }, []);

  return (
    <div style={{ width: "95%", overflow: "hidden" }} ref={attributeRef}>
      {assetKey === "type" ? (
        getAssetTypeString(asset[assetKey]) === "UNKNOWN" ? (
          <strong style={{ color: "#ce1a1a" }}>{getAssetTypeString(asset[assetKey])}</strong>
        ) : (
          getAssetTypeString(asset[assetKey])
        )
      ) : assetKey === "fileSize" ? (
        formatFileSizeAndDuration(asset[assetKey], asset["duration"])
      ) : assetKey === "framerate" ? (
        `${asset[assetKey]} FPS`
      ) : assetKey === "createdAt" ||
        assetKey === "updatedAt" ||
        assetKey === "start_time" ||
        assetKey === "end_time" ? (
        formatDate(asset[assetKey])
      ) : assetKey === "week_days" ? (
        formatScheduledDays(asset[assetKey])
      ) : assetKey === "language" ? (
        formatLanguageForAsset(asset[assetKey], asset["language_confidence_score"], t)
      ) : assetKey === "printServiceID" ? (
        formatPrintService(asset[assetKey])
      ) : assetKey === "sentToPrintServiceDate" ? (
        formatDate(asset[assetKey])
      ) : assetKey === "isProcessed" ? (
        renderCheckIcon(asset[assetKey])
      ) : assetKey === "senderToPrintService" ||
        assetKey === "owner" ||
        assetKey === "startprint_sender" ? (
        formatUser(asset[assetKey])
      ) : assetKey === "dpi" ? (
        formatDPIForAsset(asset[assetKey])
      ) : assetKey === "audio" ? (
        renderCheckIcon(asset[assetKey])
      ) : assetKey === "dynamicContent" ? (
        renderCheckIcon(asset[assetKey])
      ) : assetKey === "motiveMarker" ? (
        formatMotiveMarkerForAsset(asset[assetKey], t)
      ) : assetKey === "lowResolution" ? (
        renderCheckIcon(asset[assetKey], t)
      ) : assetKey !== "resolution" ? (
        isLoaded &&
        showElementFullTextPopup(attributeRef, asset[assetKey], "bold 1rem Lato", "#f8f8f9")
      ) : (
        asset[assetKey]
      )}
    </div>
  );
};

const AssetInfo = ({
  asset,
  isAdmin,
  agencys,
  users,
  t,
  onAssetSelected,
  isProcessed,
  campaignView,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    if (isChecked) {
      setIsChecked(false);
      onAssetSelected({ asset, isChecked: false });
    } else {
      setIsChecked(true);
      onAssetSelected({ asset, isChecked: true });
    }
  };

  const zipTypes = new Set(["application/zip", "application/x-zip-compressed", "multipart/x-zip"]);
  const isZipType = (type) => zipTypes.has(type);
  const isArrived = asset.status === "ARRIVED";

  if (!asset) return null;
  campaignView ? (asset.isProcessed = isProcessed) : (asset.isProcessed = null);
  return (
    <>
      <Grid columns={3} style={{ paddingBottom: ".5rem" }}>
        <Grid
          style={{
            marginBottom: ".5rem",
            display: "flex",
            position: "relative",
            top: "-10px",
            left: "-17px",
            alignItems: "center",
            gap: "1rem",
          }}
        ></Grid>
        <Grid.Row>
          <Grid.Column width={3} verticalAlign="middle">
            {isArrived ? (
              <div style={{ textAlign: "center" }}>
                <AssetImage asset={asset} />
              </div>
            ) : (
              <a
                href={asset.mediaUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "1rem",
                }}
                onClick={(e) => handleDownloadClick(e, asset.mediaUrl, t)}
              >
                <AssetImage asset={asset} />
                <span>
                  <Icon name="cloud download" /> {t("asset_download")}
                </span>
              </a>
            )}
          </Grid.Column>
          <Grid.Column width={12} style={{ display: "flex" }}>
            <Grid columns={2} className="info-grid">
              {(isAdmin ? ASSET_KEYS : ASSET_KEYS_CONTRIBUTOR).map((key, k) =>
                asset[key] ||
                (key === "fileSize" && (asset["fileSize"] || asset["duration"])) ||
                (asset["type"] === "application/pdf" &&
                  key === "motiveMarker" &&
                  asset["motiveMarker"] !== null) ||
                (asset["type"] === "application/pdf" &&
                  key === "lowResolution" &&
                  asset["lowResolution"] !== null) ? (
                  <Grid.Row key={key}>
                    <Grid.Column width={6}>
                      {key === "fileSize"
                        ? getFileSizeLabel(asset["fileSize"], asset["duration"], t)
                        : t("asset_" + key)}
                    </Grid.Column>
                    <Grid.Column width={10}>
                      <AssetInfoValues
                        key={key + k}
                        assetKey={key}
                        asset={asset}
                        t={t}
                        agencys={agencys}
                        users={users}
                      />
                    </Grid.Column>
                  </Grid.Row>
                ) : null
              )}
            </Grid>
          </Grid.Column>
          {!isZipType(asset["type"]) && (
            <Grid.Column floated="right" width={1}>
              <Checkbox checked={isChecked} onClick={handleClick}></Checkbox>
            </Grid.Column>
          )}
        </Grid.Row>
        {asset.api_files && <AssetAPIInfoTable apifiles={asset.api_files} t={t} />}
      </Grid>
    </>
  );
};

export default AssetInfo;
